import { create } from 'zustand';
import { modulesApi } from '../api/modules';

const useModuleStore = create((set, get) => ({
  modules: [],
  groups: {},
  enabledSet: new Set(),
  loaded: false,
  loading: false,
  error: null,

  /**
   * Module vom Server laden
   */
  fetchModules: async () => {
    if (get().loading) return;
    set({ loading: true, error: null });
    try {
      const { data } = await modulesApi.getAll();
      const enabledSet = new Set(
        data.modules.filter(m => m.enabled).map(m => m.key)
      );
      set({
        modules: data.modules,
        groups: data.groups,
        enabledSet,
        loaded: true,
        loading: false,
      });
    } catch (err) {
      // Bei Fehler: alle Module als aktiv behandeln (fail-open)
      set({ loading: false, error: err.message, loaded: true });
    }
  },

  /**
   * Pruefen ob ein Modul aktiv ist
   */
  isEnabled: (moduleKey) => {
    const { enabledSet, loaded } = get();
    // Wenn noch nicht geladen: alle aktiv (fail-open, kein Lock-out)
    if (!loaded) return true;
    return enabledSet.has(moduleKey);
  },

  /**
   * Modul aktivieren/deaktivieren
   */
  toggleModule: async (key, enabled) => {
    const { data } = await modulesApi.toggle(key, enabled);
    if (data.ok) {
      // Store aktualisieren
      await get().fetchModules();
    }
    return data;
  },

  /**
   * Preset anwenden
   */
  applyPreset: async (preset) => {
    const { data } = await modulesApi.applyPreset(preset);
    if (data.ok) {
      await get().fetchModules();
    }
    return data;
  },

  /**
   * Cache zuruecksetzen (z.B. nach Settings-Aenderung)
   */
  invalidate: () => {
    set({ loaded: false });
  },
}));

export default useModuleStore;
